export default __webpack_public_path__ + "static/media/office1-before1-2048w.a379d025.png";